<template>
  <div class="card-body py-3" v-if="!isLoaded || !isEmpty(organisation.tags)">
    <div class="d-flex justify-content-between">
      <h3 class="mb-0 t-md t-400">
        Keywords
      </h3>
      <i class="fa fa-tags t-secondary t-lr" />
    </div>
    <ul v-if="isLoaded" class="list-unstyled mb-0 mt-3 clearfix">
      <li class="badge badge-pill badge-secondary--white bd-radius pull-left mr-2 mb-2 word-overflow"
        v-for="(tag, index) in organisation.tags" :key="index" :title="tag">
        <span>{{ tag }}</span>
      </li>
    </ul>
    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'

export default {
  name: 'organisationKeywords',
  components: {
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    organisation: {
      type: Object,
      required: true
    }
  }
}
</script>
